<script>
export default {
  name: 'LmMaterialIcon',
  functional: true,
  props: {
    icon: {
      type: String,
      required: true
    },
    outline: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: null
    }
  },
  render(createElement, context) {
    const lmIconClass = ' LmMaterialIcon'
    let materialClass = context.props.outline
      ? 'material-icons-outlined'
      : 'material-icons'
    materialClass += lmIconClass
    context.data.staticClass = context.data.staticClass
      ? `${context.data.staticClass} ${materialClass}`
      : materialClass
    if (context.props.tooltip) {
      context.data.directives = context.data.directives || []
      context.data.directives.push({
        name: 'tooltip',
        value: context.props.tooltip
      })
    }
    return createElement('i', context.data, [context.props.icon])
  }
}
</script>
